export enum PortalType {
  PRODUCTION = 'PRODUCTION',
  DEVELOPMENT = 'DEVELOPMENT',
  TEST = 'TEST',
  SIMETRY = 'SIMETRY',
  REALCOM = 'REALCOM',
  SKYWAY = 'SKYWAY',
  FIDES = 'FIDES',
  VAST = 'VAST',
}

export const isProd = (portalType) => {
  return portalType.toUpperCase() === PortalType.PRODUCTION;
};

export const isDevelopment = (portalType) => {
  return portalType.toUpperCase() === PortalType.DEVELOPMENT;
};

export const isTest = (portalType) => {
  return portalType.toUpperCase() === PortalType.TEST;
};

export const isWhitelabelPortal = (portalType) => {
  return [PortalType.SIMETRY, PortalType.REALCOM, PortalType.FIDES, PortalType.SKYWAY, PortalType.VAST].includes(
    portalType.toUpperCase()
  );
};
